"use client"

import { useState, useEffect } from "react"
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "../ui/dialog"
import { Input } from "../ui/input"
import { Label } from "../ui/label"
import { Textarea } from "../ui/textarea"
import { Button } from "../ui/button"

export function ApiKeyDialog({ open, onOpenChange, apiKey, onSave, saving = false }) {
  const [form, setForm] = useState({ name: "", key: "" })

  useEffect(() => {
    apiKey
      ? setForm({ name: apiKey.name, key: apiKey.key })
      : setForm({ name: "", key: "" })
  }, [apiKey, open])

  const submit = (e) => { 
    e.preventDefault()
    if (!saving) {
      onSave(form)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] bg-black border border-gray-800 rounded-2xl shadow-2xl backdrop-blur-3xl">
        <DialogHeader className="space-y-4 pb-6">
          <DialogTitle className="text-2xl font-bold text-purple-400">
            {apiKey ? "Edit API Key" : "Add API Key"}
          </DialogTitle>
          <DialogDescription className="text-gray-400 text-base">
            Configure your API key settings and permissions with our secure interface.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={submit} className="space-y-6">
          {/* --------- nombre --------- */}
          <div className="space-y-3">
            <Label htmlFor="name" className="text-gray-300 font-medium text-sm">Key Name</Label>
            <Input
              id="name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Production Key"
              className="bg-gray-800 border border-gray-700 text-white placeholder-gray-400 rounded-xl h-12 focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-all duration-300"
              disabled={saving}
              required
            />
          </div>

          {/* --------- API Key --------- */}
          <div className="space-y-3">
            <Label htmlFor="key" className="text-gray-300 font-medium text-sm">API Key</Label>
            <Textarea
              id="key"
              value={form.key}
              onChange={(e) => setForm({ ...form, key: e.target.value })}
              placeholder="Paste your API key here…"
              className="font-mono text-sm bg-gray-800 border border-gray-700 text-white placeholder-gray-400 rounded-xl focus:border-purple-500 focus:ring-1 focus:ring-purple-500 transition-all duration-300"
              rows={3}
              disabled={saving}
              required
            />
            <p className="text-xs text-gray-400">Your API key will be stored securely and encrypted.</p>
          </div>

          <DialogFooter className="pt-6 space-x-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="bg-gray-800 border border-gray-700 text-gray-300 hover:bg-gray-700 hover:text-white rounded-xl px-6 py-3 transition-all duration-300"
              disabled={saving}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-primary hover:bg-violet-700 text-white rounded-xl px-6 py-3 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={saving}
            >
              {saving ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
                  Saving...
                </span>
              ) : (
                <>{apiKey ? "Update" : "Save"} API Key</>
              )}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
